import React, { useState } from "react";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import * as FaIcons from "react-icons/fa";

const NavItem = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  height: 44px;
  text-decoration: none;
  color: #cbd5e1;
  font-size: 13.5px;
  font-weight: 500;
  letter-spacing: 0.01em;
  border-left: 3px solid transparent;
  transition: background 180ms ease, color 180ms ease, border-color 180ms ease;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
    color: #f1f5f9;
    border-left-color: #3b82f6;
  }

  &.active-nav {
    background: rgba(59, 130, 246, 0.12);
    color: #93c5fd;
    border-left-color: #3b82f6;
  }
`;

const NavItemLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  font-size: 15px;
`;

const ChevronWrap = styled.div`
  font-size: 11px;
  color: #64748b;
  transition: transform 220ms ease;
  transform: ${({ open }) => (open ? "rotate(180deg)" : "rotate(0deg)")};
`;

const SubNavItem = styled(Link)`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 38px;
  padding: 0 16px 0 40px;
  text-decoration: none;
  color: #94a3b8;
  font-size: 12.5px;
  font-weight: 400;
  border-left: 3px solid transparent;
  transition: background 150ms ease, color 150ms ease, border-color 150ms ease;

  &:hover {
    background: rgba(255, 255, 255, 0.04);
    color: #e2e8f0;
    border-left-color: #60a5fa;
  }
`;

const SubNavIcon = styled.span`
  font-size: 13px;
  color: #475569;
`;

function Slidemenu({ item }) {
  const [subnavigation, setsubnavigation] = useState(false);
  const location = useLocation();
  const showSubnav = () => setsubnavigation(!subnavigation);
  const isActive = location.pathname === item.path;

  return (
    <>
      <NavItem
        to={item.path || "#"}
        onClick={item.subnav ? (e) => { e.preventDefault(); e.stopPropagation(); showSubnav(); } : undefined}
        className={isActive ? "active-nav" : ""}
      >
        <NavItemLeft>
          {item.icon}
          <span>{item.title}</span>
        </NavItemLeft>
        {item.subnav && (
          <ChevronWrap open={subnavigation}>
            <FaIcons.FaChevronDown />
          </ChevronWrap>
        )}
      </NavItem>

      {subnavigation &&
        item.subnav.map((i, index) => (
          <SubNavItem to={i.path} key={index}>
            <SubNavIcon>{i.icon}</SubNavIcon>
            <span>{i.title}</span>
          </SubNavItem>
        ))}
    </>
  );
}

export default Slidemenu;